import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GraphQLClient } from "graphql-request";

const fetchImagesByFileNames = async (fileNames) => {
  const query = `
    query GetImages($fileNames: [String!]) {
      assets(where: { fileName_in: $fileNames }) {
        id
        url
        fileName
      }
    }
  `;

  const variables = { fileNames };

  const client = new GraphQLClient(
    "https://api-eu-central-1-shared-euc1-02.hygraph.com/v2/clweq2m6a000001w67aqzeh7x/master"
  );

  try {
    const data = await client.request(query, variables);
    console.log(data);
    return data.assets;
  } catch (error) {
    console.error("Error fetching images:", error);
    throw error;
  }
};

const SliderComponent = ({ setIsSliderLoading, isSliderLoading }) => {
  const [imagesRetrieved, setImagesRetrieved] = useState([]);
  const imageFiles = [
    "DSC_7789.webp",
    "Beta 180.webp",
    "DSC_8530.webp",
    "DSC_8019.webp",
    "Modello staccato.webp",
    "DSC_5925.webp",
  ];

  useEffect(() => {
    const loadImages = async () => {
      try {
        const fetchedImages = await fetchImagesByFileNames(imageFiles);

        const urls = fetchedImages
          .map((asset) => asset.url)
          .filter((url) => url);
        console.log(urls);
        setImagesRetrieved(urls);
        console.log("URLS LENGHT", urls.length);
        console.log("IMAGE FILES LENGHT", imageFiles.length);

        if (urls.length === imageFiles.length) {
          console.log("All images loaded successfully");
          setIsSliderLoading(false);
        } else {
          console.warn("Some images did not load correctly");
        }
      } catch (error) {
        console.error("Error loading images:", error);
      }
    };

    loadImages();
  }, [setIsSliderLoading]);

  const settings = {
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
  };

  return (
    <>
      {isSliderLoading ? (
        <div className="w-screen h-[500px] flex items-center justify-center bg-gray-200">
          <p className="text-2xl font-bold">Loading slider...</p>
        </div>
      ) : (
        <Slider {...settings}>
          {imagesRetrieved.map((image, index) => (
            <div key={index}>
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="object-cover"
                style={{
                  width: "100%",
                  maxHeight: "500px",
                  minHeight: "500px",
                }}
                loading="lazy"
              />
            </div>
          ))}
        </Slider>
      )}
    </>
  );
};

export default SliderComponent;
